// 固定资产管理 | store 索引
// Date 2026-09-07

import emArchFixedAssetChange from "@/store/em/asset/EmArchFixedAssetChangeStore.js";
import emArchFixedAssetDisposal from "@/store/em/asset/EmArchFixedAssetDisposalStore.js";

const genericEntities = [
    'emArchFixedAssetChange',
    'emArchFixedAssetDisposal'
]

const entities = {
    emArchFixedAssetChange,
    emArchFixedAssetDisposal
}

export {genericEntities}

export default entities
